<div class="row">
  <div class="col-12">
    <nb-card>
      <nb-card-header>
        <div class="header-container">
          <h4>Cards for {{ userName || 'User' }}</h4>
          <div class="header-actions">
            <button
              nbButton
              status="primary"
              size="small"
              class="btn-add-card"
              (click)="openAddCardDialog()"
            >
              <nb-icon icon="plus-outline"></nb-icon>
              Add Card UID
            </button>
            <button
              nbButton
              status="basic"
              size="small"
              class="btn-back"
              (click)="goBack()"
            >
              <nb-icon icon="arrow-back-outline"></nb-icon>
              Back
            </button>
          </div>
        </div>
      </nb-card-header>

      <nb-card-body>
        <!-- Loading Spinner -->
        <div *ngIf="loading" class="loading-container">
          <nb-spinner status="primary"></nb-spinner>
          <span>Loading card data...</span>
        </div>

        <!-- Error Message -->
        <nb-alert *ngIf="error && !loading" status="danger">{{ error }}</nb-alert>

        <!-- Cards Table -->
        <div *ngIf="!loading && !error && userCards.length > 0" class="user-cards-table-container">
          <table class="user-cards-table">
            <thead>
              <tr>
                <th>Card UID</th>
                <th>Store</th>
                <th>Linked Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let card of userCards">
                <td><code>{{ card.cardUID }}</code></td>
                <td>{{ card.storeName || 'Unknown Store' }}</td>
                <td>{{ formatTimestamp(card.createdAt) }}</td>
                <td class="actions-cell">
                  <button
                    nbButton
                    status="warning"
                    size="small"
                    (click)="openEditCardDialog(card)"
                    nbTooltip="Edit Card"
                    class="btn-action"
                  >
                    <nb-icon icon="edit-2-outline"></nb-icon>
                  </button>
                  <button
                    nbButton
                    status="danger"
                    size="small"
                    (click)="deleteCard(card._id, card.cardUID)"
                    nbTooltip="Delete Card"
                    class="btn-action"
                  >
                    <nb-icon icon="trash-2-outline"></nb-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- No Cards Message -->
        <nb-alert *ngIf="!loading && !error && userCards.length === 0" status="info">
          This user has no linked cards. Use the "Add Card UID" button above to link a card.
        </nb-alert>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
</ngx-spinner>

<!-- Add Card UID Dialog Template -->
<ng-template #addCardTemplate>
  <nb-card class="dialog-card">
    <nb-card-header>Add Card UID</nb-card-header>
    <nb-card-body>
      <div class="form-group">
        <label class="label">Card UID <span class="required">*</span></label>
        <input
          nbInput
          fullWidth
          [(ngModel)]="newCardUID"
          placeholder="Enter Card UID"
          [disabled]="addCardSubmitting"
        />
      </div>
      <div class="form-group">
        <label class="label">Store <span class="required">*</span></label>
        <select
          class="form-select nb-select-like"
          [(ngModel)]="newCardStoreId"
          [disabled]="addCardSubmitting || storesLoading"
        >
          <option value="" disabled>{{ storesLoading ? 'Loading stores...' : 'Select a store' }}</option>
          <option *ngFor="let store of stores" [value]="store._id">
            {{ store.storeName || store.name }}
          </option>
        </select>
      </div>
    </nb-card-body>
    <nb-card-footer class="dialog-footer">
      <button
        nbButton
        status="basic"
        size="small"
        (click)="addCardDialogRef?.close()"
        [disabled]="addCardSubmitting"
      >
        Cancel
      </button>
      <button
        nbButton
        status="primary"
        size="small"
        (click)="submitAddCard()"
        [disabled]="addCardSubmitting || !newCardUID.trim() || !newCardStoreId"
      >
        <nb-icon *ngIf="addCardSubmitting" icon="loader-outline"></nb-icon>
        {{ addCardSubmitting ? 'Linking...' : 'Link Card' }}
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<!-- Edit Card Dialog Template -->
<ng-template #editCardTemplate>
  <nb-card class="dialog-card">
    <nb-card-header>Edit Card</nb-card-header>
    <nb-card-body>
      <div class="form-group">
        <label class="label">Card UID <span class="required">*</span></label>
        <input
          nbInput
          fullWidth
          [(ngModel)]="editCardUID"
          placeholder="Enter Card UID"
          [disabled]="editCardSubmitting"
        />
      </div>
      <div class="form-group">
        <label class="label">Store <span class="required">*</span></label>
        <select
          class="form-select nb-select-like"
          [(ngModel)]="editCardStoreId"
          [disabled]="editCardSubmitting || storesLoading"
        >
          <option value="" disabled>{{ storesLoading ? 'Loading stores...' : 'Select a store' }}</option>
          <option *ngFor="let store of stores" [value]="store._id">
            {{ store.storeName || store.name }}
          </option>
        </select>
      </div>
    </nb-card-body>
    <nb-card-footer class="dialog-footer">
      <button
        nbButton
        status="basic"
        size="small"
        (click)="editCardDialogRef?.close()"
        [disabled]="editCardSubmitting"
      >
        Cancel
      </button>
      <button
        nbButton
        status="primary"
        size="small"
        (click)="submitEditCard()"
        [disabled]="editCardSubmitting || !editCardUID.trim() || !editCardStoreId"
      >
        <nb-icon *ngIf="editCardSubmitting" icon="loader-outline"></nb-icon>
        {{ editCardSubmitting ? 'Saving...' : 'Save Changes' }}
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>
